import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Vision from 'components/vision';

type Props = {
  data: Object,
};

const VisionAndValuesPage = ({ data }: Props) => {
  const {
    visionJson,
    getInTouchJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...visionJson,
        getInTouch: getInTouchJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <Vision />
      </Layout>
    </Website>
  );
};

export default VisionAndValuesPage;

export const query = graphql`
  query VisionPageQuery {
    visionJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      vision {
        title
        subtitle
        text
      }
      values {
        title
        tabs {
          id
          label
          title
          text
        }
      }
      slider {
        images {
          xl
          lg
          md
          sm
          xs
        }
      }
      meta {
        description
        title
      }
    }
    getInTouchJson {
      ...GetInTouchJsonFragment
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
